import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { cancelRide } from '../api/services/Rides';
import { CancelRidePayload } from '../types/rides';

import { RIDE_DETAILS_QUERY_KEY } from './useRideDetailsQuery';
import { RIDE_OVERVIEW_QUERY_KEY } from './useRideOverviewQuery';

interface iUseCancelRideSubmit {
  rideSlug: string;
  successCallback?: () => void;
  errorCallback?: (
    error:
      | Error & {
          errors: string[];
        }
  ) => void;
}

export const useCancelRideSubmit = ({ rideSlug, successCallback, errorCallback }: iUseCancelRideSubmit) => {
  return useApiSend(
    (payload: CancelRidePayload) => cancelRide(rideSlug, payload),
    successCallback,
    errorCallback,
    [RIDE_DETAILS_QUERY_KEY, RIDE_OVERVIEW_QUERY_KEY],
    undefined
  );
};
